import { render, staticRenderFns } from "./VAssets.vue?vue&type=template&id=2266254b&"
import script from "./VAssets.vue?vue&type=script&lang=js&"
export * from "./VAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports